import { colorPalette } from '@dermloop/ui/util';
import { device } from '@dermloop/ui/web/util';
import styled from 'styled-components';
import AppScreenshot from '../assets/app-screenshot.webp';
import { ReactComponent as AppStoreWhiteIcon } from '../assets/appstore-white-icon.svg';
import CheckMarkIcon from '../assets/check-mark-icon.svg';
import { ReactComponent as MelatechLogo } from '../assets/melatech-logo.svg';
import { ReactComponent as PlayStoreWhiteIcon } from '../assets/playstore-white-icon.svg';
import { HeaderBackground } from './header-background';

const StyledHeader = styled.header`
  position: relative;
  display: flex;
  flex-direction: column;

  color: ${colorPalette.white};

  @media ${device.tablet} {
    min-height: 100vh;
    color: ${colorPalette.foreground};
    justify-content: center;
    align-items: center;
  }
`;

const StyledAppBadges = styled.div`
  display: flex;
  justify-content: center;

  @media ${device.tablet} {
    justify-content: flex-start;
  }
  padding: 1rem 0;

  a:first-child {
    margin-right: 20px;
  }

  a {
    flex-grow: 1;
    max-width: 13rem;
  }
  svg {
    width: 100%;
  }
`;

const StyledWrapper = styled.div`
  width: 100%;
  flex-direction: column;

  @media ${device.tablet} {
    width: 90vw;
    flex-direction: row;
  }

  @media ${device.laptopL} {
    width: 70vw;
  }

  justify-content: space-between;

  display: flex;
`;

const StyledAppScreenshot = styled.img`
  margin: 2rem 0;
  align-self: center;
  width: 50vw;

  @media ${device.tablet} {
    align-self: end;
    width: 300px;
  }

  z-index: 1;
`;

const StyledHeaderContent = styled.div`
  flex-direction: column;
  padding: 2rem;
  display: flex;
  text-align: center;
  position: relative;
  background: ${colorPalette.green.DEFAULT};

  @media ${device.tablet} {
    background: none;
    max-width: 520px;
    text-align: left;
    position: static;
  }
`;

const StyledLogo = styled.div`
  width: 130px;

  @media ${device.tablet} {
    width: 250px;
  }
`;

const StyledNavigation = styled.nav`
  padding: 0 2rem;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-self: stretch;
  align-items: center;
  height: 8rem;
  background: ${colorPalette.green.DEFAULT};

  @media ${device.tablet} {
    background: none;
    padding: 0 4rem;
  }
`;

const StyledDescription = styled.p`
  font-size: 1.5rem;
  font-weight: 500;
`;

const StyledHeading = styled.h1`
  font-size: 2.375rem;
`;

const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  display: none;
  @media ${device.tablet} {
    display: unset;
  }

  & > li {
    padding: 1rem 0;
    display: flex;
    align-items: center;
    height: 1.5rem;
  }

  & > li:before {
    content: '';
    height: 1.5rem;
    width: 1.5rem;
    margin-right: 1rem;
    background-image: url('${CheckMarkIcon}');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position: center;
    transition: background-size 0.3s;
  }
`;

export function Header() {
  return (
    <StyledHeader>
      <StyledNavigation>
        <StyledLogo>
          <MelatechLogo />
        </StyledLogo>
      </StyledNavigation>
      <StyledWrapper>
        <StyledHeaderContent>
          <StyledHeading>Dermloop Learn</StyledHeading>
          <StyledDescription>
            AI driven training app to help you become an expert diagnostician
            before seeing your first patient.
          </StyledDescription>
          <StyledList>
            <li>Free of charge</li>
            <li>Track your performance and learn where to improve</li>
            <li>20.000 + real life anonymous skin lesions to practice on</li>
          </StyledList>
          <StyledAppBadges>
            <a href="https://apps.apple.com/dk/app/dermloop-learn/id1549189119">
              <AppStoreWhiteIcon />
            </a>
            <a href="https://play.google.com/store/apps/details?id=io.dermloop.learn&hl=en&gl=US">
              <PlayStoreWhiteIcon />
            </a>
          </StyledAppBadges>
        </StyledHeaderContent>
        <HeaderBackground />
        <StyledAppScreenshot src={AppScreenshot} />
      </StyledWrapper>
    </StyledHeader>
  );
}
